import React from 'react';
import classNames from 'classnames';
import UserAvatarImage, { type UserAvatarImageProps } from '../user-avatar-image';
import UserName from '../user-name';
import styles from './avatar.scss';

type Props = {
  user: UserAvatarImageProps['user'];
  type?: UserAvatarImageProps['type'];
  isImageVisible?: boolean;
  isNameVisible?: boolean;
};

const Avatar = ({ type, user, isImageVisible = true, isNameVisible = true }: Props) => {
  const name = user && 'name' in user ? user.name : undefined;
  const className = classNames(
    styles.container,
    'blog-text-color',
    'blog-link-hover-color',
    'avatar',
    'blog-post-text-color',
  );
  return (
    <span className={className}>
      {isImageVisible && <UserAvatarImage type={type} user={user} />}
      {isNameVisible && name && <UserName className={styles.name} name={name} />}
    </span>
  );
};

export default Avatar;
